import { blockOnLive } from "routes/guards/liveGuard";

const balanceRoutes = [
  {
    path: "balance",
    // Mock data until the payouts API ships, so keep it off live.
    lazy: blockOnLive(async () => {
      const mod = await import("views/Admin/Balance");
      const Balance = mod.default;
      return { Component: Balance };
    }),
  },
];

export default balanceRoutes;
